<template>
  <ul id="main-menu" class="d-flex align-items-center list-unstyled mb-0 gap-1" v-if="!agency?.isCollaborator">
    <li class="menu-item">
      <router-link
        v-if="can('agency.index')"
        id="admin-paxs"
        :aria-label="$t('general.adminMenu.paxs')"
        :to="{ name: 'pax.index' }"
        class="nav-link"
        @click="closeMenu"
      >
        {{ $t('general.adminMenu.paxs') }}
      </router-link>
    </li>
    <li class="menu-item">
      <router-link
        v-if="can('user.index')"
        id="admin-users"
        :aria-label="$t('general.adminMenu.users')"
        :to="{ name: 'user.index' }"
        class="nav-link"
        @click="closeMenu"
      >
        {{ $t('general.adminMenu.users') }}
      </router-link>
    </li>

    <li class="menu-item">
      <router-link
        v-if="can('agency.index')"
        id="admin-agencies"
        :aria-label="$t('general.adminMenu.agencies')"
        :to="{ name: 'agency.index' }"
        class="nav-link"
        @click="closeMenu"
      >
        {{ $t('general.adminMenu.agencies') }}
      </router-link>
    </li>
    <li class="menu-item">
      <router-link
        v-if="can('agency.index')"
        id="admin-collaborators"
        :aria-label="this.$t('general.adminMenu.collaborators')"
        :to="{ name: 'collaborators' }"
        class="nav-link"
        @click="closeMenu"
      >
        {{ $t('general.adminMenu.collaborators') }}
      </router-link>
    </li>
    <li class="menu-item">
      <router-link
        v-if="can('agency.index')"
        id="admin-logs"
        :aria-label="$t('general.adminMenu.logs')"
        :to="{ name: 'admin.logs' }"
        class="nav-link"
        @click="closeMenu"
      >
        {{ $t('general.adminMenu.logs') }}
      </router-link>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import useCapabilities from '@/helpers/capabilities';

export default defineComponent({
  name: 'TheAdminMenu',
  setup() {
    return {
      ...useCapabilities(),
    };
  },
  computed: {
    ...mapState(useAuthStore, ['user']),
    ...mapState(useAuthStore, ['agency']),
  },
  methods: {
    closeMenu() {
      const main: any = document.getElementById('main');
      const buttonClose: any = document.getElementById('btn-header-hamburger');

      if (!!buttonClose && main.classList.contains('menu-open')) {
        buttonClose.click();

        buttonClose.classList.remove('is-active');
        main.classList.remove('menu-open');
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.nav-link {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: #6c757d;
  transition: all 0.2s ease;
  border-radius: 4px;
  text-decoration: none;

  &:hover {
    color: #212529;
    background-color: #e9ecef;
  }

  &.router-link-active {
    color: #ffffff !important;
    background-color: #000000 !important;
  }
}
</style>
